import axios from "axios";
import { BACKEND_DOMAIN } from "../common/env";

export const checkIfAdmin = async (auctionId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return false; // Unauthenticated users are not admins
      }
      const response = await axios.get(`${BACKEND_DOMAIN}/auctions/${auctionId}/is-admin`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.isAdmin;
    } catch (error) {
      console.error("Error checking admin status:", error);
      return false; // Default to false on error
    }
};


export const checkIfAdminOfMatch = async (matchId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BACKEND_DOMAIN}/volleyball-matches/${matchId}/is-admin`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.isAdmin;
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
};
